import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BenjiKIV} from "../../BenjiKIV";
import {PointerStateColorSet} from "@nolimitcity/slot-launcher/bin/gui/buttons/states/sets/PointerStateColorSet";
import {IconToggleButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/IconToggleButton";
import {Icon} from "@nolimitcity/slot-launcher/bin/gui/displayobjects/Icon";
import {PointerStateIconSet} from "@nolimitcity/slot-launcher/bin/gui/buttons/states/sets/PointerStateIconSet";
import {BonusFeatureData} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/BonusFeatures";
import {BetBoostData} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetHandler";
import {gsap} from "gsap";
import {BenjiKIVGameMode} from "../../server/BenjiKIVGameMode";
import {BenjiKIVSound} from "../../sound/BenjiKIVSound";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {PromoPanelEvents} from "@nolimitcity/promo-panel/bin/events/PromoPanelEvents";

/**
 * Created by Jerker Nord on 2022-12-19.
 */

export class BenjiKIVXBetView extends PIXI.Container implements StageLayer {

    public static BOOST_BET_1: string = "BOOSTED_BET";
    public static BOOST_BET_2: string = "BOOSTED_BET_2";

    private static BUTTON_01_LANDSCAPE_4BY3_POSITION: PIXI.Point = new PIXI.Point(710, 210);
    private static BUTTON_02_LANDSCAPE_4BY3_POSITION: PIXI.Point = new PIXI.Point(710, 100);
    private static BUTTON_01_PORTRAIT_POSITION: PIXI.Point = new PIXI.Point(570, -40);
    private static BUTTON_02_PORTRAIT_POSITION: PIXI.Point = new PIXI.Point(460, -40);

    private _level01Button: IconToggleButton;
    private _level02Button: IconToggleButton;
    private _betBoostAllowed: boolean = false;
    private _betBoostPaused: boolean = false;
    private _activateBoost2TL: gsap.core.Timeline;
    private _level01OnSprite: PIXI.Sprite;
    private _level02OnSprite: PIXI.Sprite;
    private _level01Normal: PIXI.Sprite;
    private _level02Normal: PIXI.Sprite;
    private _level01Attention: TimelineSprite;
    private _level02Attention: TimelineSprite;
    private _attentionTl: gsap.core.Timeline | null;
    private _xBetBlueReelOverlay: PIXI.Sprite;
    private _xBetBlueReelOverlayTl: gsap.core.Timeline;
    private _isReplay:boolean;
    private _isFeatureBuyAbort:boolean;
    private _isFreeBets:boolean;

    // #260
    private _hasBetPlaced: boolean = false;
    private _isPromoPanelClosed: boolean = true;
    private _isBoost1EnabledFromKeypad: boolean = true;
    private _isBoost2EnabledFromKeypad: boolean = true;

    constructor() {
        super();
        this.name = "BenjiKIVXBetView";

        // https://github.com/nolimitcity/QA/issues/587
        this._isBoost2EnabledFromKeypad = BenjiKIV.xBetRedAllowed;

        this.init();
    }

    private _boosted01Enabled: boolean = false;

    get boosted01Enabled(): boolean {
        return this._boosted01Enabled;
    }

    private _boosted02Enabled: boolean = false;

    get boosted02Enabled(): boolean {
        return BenjiKIV.xBetRedAllowed && this._boosted02Enabled; // https://github.com/nolimitcity/QA/issues/587
    }

    private init(): void {
        this._betBoostAllowed = BenjiKIV.apiPlugin.gameClientConfiguration.boostedBetAllowed;
        this._isReplay = false;
        this._isFeatureBuyAbort = false;
        this._isFreeBets = false;

        if (this._betBoostAllowed) {
            this.createBoostButton();
            if (BenjiKIV.model.isRestore) {
                if (BenjiKIV.model.data.mode == BenjiKIVGameMode.FREESPIN
                    || BenjiKIV.model.data.mode == BenjiKIVGameMode.SUPER_FREESPIN
                    || (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.FREESPIN)
                    || (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.FREESPIN) // #221
                    || (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.SUPER_FREESPIN)
                    || (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.SUPER_FREESPIN)) { // #221

                    this.hide();
                    if (BenjiKIV.model.enhancedBet > 0) {
                        this.turnOnBoost(false);
                    }
                }

                // #221
                if ((BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN) && BenjiKIV.model.enhancedBet === 1) {
                    this.turnOnBoost(false);
                    this.stopXBetBlueReelOverlay();
                }

                if (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN) {
                    this.enableButtons(false);
                }
            }

            if (BenjiKIV.apiPlugin.isReplay) {
                this.enableButtons(false);
                if (BenjiKIV.model.initData.nextPlayerInteraction?.featureName == BenjiKIVXBetView.BOOST_BET_1
                    || BenjiKIV.model.initData.nextPlayerInteraction?.featureName == BenjiKIVXBetView.BOOST_BET_2) {
                    this.turnOnBoost(true);
                } else {
                    this.turnOffBoost(true);
                }
                this._isReplay = true;
            } else if (BenjiKIV.apiPlugin.freeBets.hasFreeBets()) {
                this.enableButtons(false);
                this.turnOffBoost(true);
                this.hide();
                BenjiKIV.apiPlugin.freeBets.events.once(BenjiKIV.apiPlugin.freeBets.FREE_BETS_END, () => {
                    this.turnOffBoost(false);
                    this.enableButtons(true);
                    this.show();
                    this._isFreeBets = false;
                });
            }

            BenjiKIV.apiPlugin.freeBets.events.on(BenjiKIV.apiPlugin.freeBets.FREE_BETS_START, () => {
                this._isFreeBets = true;
                this.enableButtons(false);
                this.turnOffBoost(true);
                this.hide();

                BenjiKIV.apiPlugin.freeBets.events.once(BenjiKIV.apiPlugin.freeBets.FREE_BETS_END, () => {
                    this.turnOffBoost(false);
                    this.enableButtons(true);
                    this.show();
                    this._isFreeBets = false;
                });
            });

            // #260
            BenjiKIV.apiPlugin.events.on(APIEvent.CURRENT_BET, (currentBet: string) => {
                this.onBetLevelChangeFromKeypad(parseFloat(currentBet));
            });
            BenjiKIV.apiPlugin.events.on(PromoPanelEvents.PROMO_PANEL_OPENED, () => {
                this.onPromoPanelOpened();
            });
            BenjiKIV.apiPlugin.events.on(PromoPanelEvents.PROMO_PANEL_CLOSED, () => {
                this.onPromoPanelClosed();
            });

            // #260 -> 8th feb, 2024 comments.
            if (BenjiKIV.betOnInit) {
                this.onBetLevelChangeFromKeypad(BenjiKIV.betOnInit);

                BenjiKIV.betOnInit = 0;
            }
        }

        this.onResize();
    }

    public enableButtons(value: boolean = false): void {
        if (!this._betBoostAllowed || this._betBoostPaused || this._isReplay || this._isFeatureBuyAbort || this._isFreeBets) {
            return;
        }

        this._level01Button.enable(value && this._isBoost1EnabledFromKeypad); // #260 => modified

        // https://github.com/nolimitcity/QA/issues/587
        if (BenjiKIV.xBetRedAllowed) {
            this._level02Button.enable(value && this._isBoost2EnabledFromKeypad); // #260 => modified
        }

        // #175
        if (value) {
            this.tryBlueXBetReelOverlay();
        }

        if (value) {
            this.playAttentionTl();
        } else {
            this.killAttention();
        }
    }

    public turnOffBoost(pauseBoost: boolean): void {
        if (!this._betBoostAllowed) {
            return;
        }
        if (this._level01Button.toggled) {
            this.level01Toggle();
        }
        if (this._level02Button.toggled) {
            this.level02Toggle();
        }
        this._betBoostPaused = pauseBoost;
    }

    public hide(): void {
        this.visible = false;
    }
    public turnOffButtonShowForAS():void{
        if(!this._betBoostAllowed) {
            //#302
            return;
        }


        this._level01Normal.visible=true;
        this._level01OnSprite.visible=false;
        this._level02Normal.visible=true;
        this._level02OnSprite.visible=false;
        //disabling xBet Buttons
        BenjiKIV.xBetView.enableButtons(false);
    }

    public show(): void {
        if (!this._isFreeBets){
            this.visible = true;
            this._isFeatureBuyAbort = false;
        }
    }

    public onResize(): void {
        if (this._level01Button && this._level02Button) {
            if (NolimitApplication.isLandscape) {
                const bounds: ScreenBounds = NolimitApplication.screenBounds;

                if (bounds.width <= 970) {
                    this._level01Button.position = BenjiKIVXBetView.BUTTON_01_LANDSCAPE_4BY3_POSITION;
                    this._level02Button.position = BenjiKIVXBetView.BUTTON_02_LANDSCAPE_4BY3_POSITION;
                } else {
                    const spinButtonWidth: number = 300,
                        edgeMarginX: number = 10,
                        spinCenterX: number = (bounds.right - edgeMarginX - spinButtonWidth * 0.5);

                    this._level01Button.position = new PIXI.Point(spinCenterX - (this._level01Button.width * 0.5), 150);
                    this._level02Button.position = new PIXI.Point(spinCenterX - (this._level02Button.width * 0.5), 30);
                }
            } else {
                this._level01Button.position = BenjiKIVXBetView.BUTTON_01_PORTRAIT_POSITION;
                this._level02Button.position = BenjiKIVXBetView.BUTTON_02_PORTRAIT_POSITION;
            }

            this._level01Normal.position = this._level01Button.position;
            this._level02Normal.position = this._level02Button.position;

            this._level01OnSprite.position = this._level01Button.position;
            this._level02OnSprite.position = this._level02Button.position;
        }
    }

    // #241
    public tryBlueXBetReelOverlay(): void {
        if(!this._betBoostAllowed){
            //#302
            return;
        }


        if (this._level01Button && this._level01Button.toggled) {
            this.playXBetBlueReelOverlay();
        }
    }

    // #175
    public stopXBetBlueReelOverlay(): void {
        if (!this._betBoostAllowed){
            return;
        }

        const tl: gsap.core.Timeline = gsap.timeline();

        if (!this._xBetBlueReelOverlay.visible) {
            return;
        }

        if (this._xBetBlueReelOverlayTl) {
            this._xBetBlueReelOverlayTl.pause();
            this._xBetBlueReelOverlayTl.kill();
        }

        tl.to(this._xBetBlueReelOverlay, {
            duration: 0.1,
            alpha: 0
        });
        tl.add(() => {
            this._xBetBlueReelOverlay.visible = false;
            this._xBetBlueReelOverlay.alpha = 1;
        });

        this._xBetBlueReelOverlayTl = tl;
    }

    public turnOnBoost(pauseBoost: boolean): void {
        if (!this._betBoostAllowed) {
            return;
        }
        if (!this._level01Button.toggled && BenjiKIV.model.enhancedBet == 1 || BenjiKIV.model.initData.nextPlayerInteraction?.featureName == BenjiKIVXBetView.BOOST_BET_1) {
            this.level01Toggle();
        } else if (!this._level02Button.toggled && BenjiKIV.model.enhancedBet == 2 || BenjiKIV.model.initData.nextPlayerInteraction?.featureName == BenjiKIVXBetView.BOOST_BET_2) {
            this.level02Toggle();
        }
        this._betBoostPaused = pauseBoost;
    }

    public turnOnxBet1():void{
        if (!this._betBoostAllowed || this._betBoostPaused || this._isReplay || this._isFeatureBuyAbort || this._isFreeBets) {
            return;
        }
        this.killAttention();
        if (this._level02Button.toggled) {
            this._level02Button.toggled = false;
            BenjiKIV.overlayScatterView.deActivateBoostedOverlays();
            this._boosted02Enabled = false;
            this._level02OnSprite.visible = false;
        }
        this._level02Normal.visible = false;
        this._level02Button.enable(false);
        this._level02Button.interactive = this._isBoost2EnabledFromKeypad; // #260 => modified
        this._level02Button.buttonMode = this._isBoost2EnabledFromKeypad; // #260 => modified

        const featureData: BonusFeatureData | undefined = BenjiKIV.apiPlugin.bonusFeatures.getFeatureDataByName(BenjiKIVXBetView.BOOST_BET_1);
        if (featureData) {
            let data: BetBoostData = {
                featureName: featureData.name,
                price: featureData.price
            }
            // BenjiKIV.apiPlugin.betHandler.setBoost(data);
            this._boosted01Enabled = true;
        }
        this.playXBetBlueReelOverlay();
        this._level01Button.toggled = true;
        this._level01OnSprite.visible = true;
        this._level01Normal.alpha = 1;
    }

    public level01Toggle(playSound: boolean = false,callFromASPromoPanel:boolean=false): void {
        if (!this._betBoostAllowed || this._betBoostPaused || this._isReplay || this._isFeatureBuyAbort || this._isFreeBets) {
            return;
        }

        this.killAttention();

        if (!this._level01Button.toggled) {
            if (this._level02Button.toggled) {
                this._level02Button.toggled = false;
                if(!callFromASPromoPanel){
                    BenjiKIV.overlayScatterView.deActivateBoostedOverlays();
                }
                this._boosted02Enabled = false;

                this._level02OnSprite.visible = false;
            }

            this._level02Normal.visible = false;

            this._level02Button.enable(false);
            this._level02Button.interactive = this._isBoost2EnabledFromKeypad; // #260 => modified
            this._level02Button.buttonMode = this._isBoost2EnabledFromKeypad; // #260 => modified

            const featureData: BonusFeatureData | undefined = BenjiKIV.apiPlugin.bonusFeatures.getFeatureDataByName(BenjiKIVXBetView.BOOST_BET_1);
            if (featureData) {
                let data: BetBoostData = {
                    featureName: featureData.name,
                    price: featureData.price
                }
                BenjiKIV.apiPlugin.betHandler.setBoost(data);
                this._boosted01Enabled = true;
            }

            this.playXBetBlueReelOverlay();

            this._level01Button.toggled = true;
            this._level01OnSprite.visible = true;
            this._level01Normal.alpha = 1;
            if (playSound) {
                BenjiKIV.soundPlayer.playSound(BenjiKIVSound.BLUE_XBET_ON);
            }
        } else {
            if(callFromASPromoPanel){
                return;
            }
            if (playSound) {
                BenjiKIV.soundPlayer.playSound(BenjiKIVSound.XBET_OFF);
            }
            this._boosted01Enabled = false;
            BenjiKIV.apiPlugin.betHandler.setBoost(undefined);
            this._level01Button.toggled = false;
            this._level01OnSprite.visible = false;

            // https://github.com/nolimitcity/QA/issues/587
            if (BenjiKIV.xBetRedAllowed) {
                this._level02Button.enable(this._isBoost2EnabledFromKeypad); // #260 => modified
                this._level02Normal.visible = true;
            }

            this._level01Normal.visible = true;

            this._level01Normal.alpha = (this._isBoost1EnabledFromKeypad ? 1 : 0.4);
            this._level02Normal.alpha = (this._isBoost2EnabledFromKeypad ? 1 : 0.4);

            if (!this._level02OnSprite.visible) {
                this.playAttentionTl();
            }

            this.stopXBetBlueReelOverlay();
        }
    }

    public turnOnXbetLevel2(callFromASPromoPanel:boolean=false):void{
        if (!this._betBoostAllowed || this._betBoostPaused || this._isReplay || this._isFeatureBuyAbort || this._isFreeBets) {
            return;
        }
        this.killAttention();
        if (!BenjiKIV.xBetRedAllowed) {
            return;
        }
        this._level01Button.toggled = false;
        this._boosted01Enabled = false;

        this.stopXBetBlueReelOverlay();

        this._level01OnSprite.visible = false;
        this._level01Normal.visible = false;

        this._level01Button.enable(false);
        this._level01Button.interactive = this._isBoost1EnabledFromKeypad; // #260 => modified
        this._level01Button.buttonMode = this._isBoost1EnabledFromKeypad; // #260 => modified

        const featureData: BonusFeatureData | undefined = BenjiKIV.apiPlugin.bonusFeatures.getFeatureDataByName(BenjiKIVXBetView.BOOST_BET_2);
        if (featureData) {
            let data: BetBoostData = {
                featureName: featureData.name,
                price: featureData.price
            }
            this._boosted02Enabled = true;
            if (!BenjiKIV.model.isRestore) {
                this._activateBoost2TL = gsap.timeline();
                if((BenjiKIV.model.betWayWins && BenjiKIV.model.betWayWins.length == 0 && !callFromASPromoPanel) || BenjiKIV.individualWin.individualWinPlaying) {
                    this._activateBoost2TL.add(() => BenjiKIV.overlayScatterView.activateBoostedOverlays());
                }
            }
        }
        this._level02Button.toggled = true;
        this._level02OnSprite.visible = true;
        this._level02Normal.alpha = 1;

    }

    public level02Toggle(playSound: boolean = false,callFromASPromoPanel:boolean=false): void {
        if (!this._betBoostAllowed || this._betBoostPaused || this._isReplay || this._isFeatureBuyAbort || this._isFreeBets) {
            return;
        }

        this.killAttention();

        // https://github.com/nolimitcity/QA/issues/587
        if (!BenjiKIV.xBetRedAllowed) {
            return;
        }

        if (!this._level02Button.toggled) {
            if (this._level01Button.toggled) {
                this._level01Button.toggled = false;
                this._boosted01Enabled = false;

                this.stopXBetBlueReelOverlay();

                this._level01OnSprite.visible = false;
            }

            this._level01Normal.visible = false;

            this._level01Button.enable(false);
            this._level01Button.interactive = this._isBoost1EnabledFromKeypad; // #260 => modified
            this._level01Button.buttonMode = this._isBoost1EnabledFromKeypad; // #260 => modified

            const featureData: BonusFeatureData | undefined = BenjiKIV.apiPlugin.bonusFeatures.getFeatureDataByName(BenjiKIVXBetView.BOOST_BET_2);
            if (featureData) {
                let data: BetBoostData = {
                    featureName: featureData.name,
                    price: featureData.price
                }
                if(!callFromASPromoPanel){
                    BenjiKIV.apiPlugin.betHandler.setBoost(data);
                }
                this._boosted02Enabled = true;
                if (!BenjiKIV.model.isRestore) {
                    this._activateBoost2TL = gsap.timeline();
                    if((BenjiKIV.model.betWayWins && BenjiKIV.model.betWayWins.length == 0 && !callFromASPromoPanel) || BenjiKIV.individualWin.individualWinPlaying) {
                        this._activateBoost2TL.add(() => BenjiKIV.overlayScatterView.activateBoostedOverlays());
                    }
                }
            }
            this._level02Button.toggled = true;
            this._level02OnSprite.visible = true;
            this._level02Normal.alpha = 1;
            if (playSound) {
                BenjiKIV.soundPlayer.playSound(BenjiKIVSound.RED_XBET_ON);
            }
        } else {
            if(callFromASPromoPanel){
                return;
            }
            if(!callFromASPromoPanel){
                BenjiKIV.apiPlugin.betHandler.setBoost(undefined);
            }
            this._boosted02Enabled = false;
            if (this._activateBoost2TL && this._activateBoost2TL.isActive()) {
                this._activateBoost2TL.pause();
            }
            // if(!callFromASPromoPanel){
                BenjiKIV.overlayScatterView.deActivateBoostedOverlays();
            // }
            this._level02Button.toggled = false;
            this._level02OnSprite.visible = false;
            if (playSound) {
                BenjiKIV.soundPlayer.playSound(BenjiKIVSound.XBET_OFF);
            }

            this._level01Button.enable(this._isBoost1EnabledFromKeypad); // #260 => modified
            this._level01Normal.visible = true;
            this._level02Normal.visible = true;

            this._level01Normal.alpha = (this._isBoost1EnabledFromKeypad ? 1 : 0.4);
            this._level02Normal.alpha = (this._isBoost2EnabledFromKeypad ? 1 : 0.4);

            if (!this._level01OnSprite.visible) {
                this.playAttentionTl();
            }
        }
    }

    private createBoostButton(): void {
        const colorSet: PointerStateColorSet = new PointerStateColorSet(
            0xFFFFFFFF,
            0xFFFFFFFF,
            0xFFFFFFFF,
            0xFFFFFFFF
        );
        const textureName01: string = "X_Bet/Xbet_B_";
        const onTextureName01: string = textureName01 + "On";
        const offTextureName01: string = textureName01 + "Off";

        this._level01Button = new IconToggleButton("level1",
            new PointerStateIconSet(
                new Icon(BenjiKIV.assetLoader.getTextures(onTextureName01)[0]),
                new Icon(BenjiKIV.assetLoader.getTextures(onTextureName01)[0]),
                new Icon(BenjiKIV.assetLoader.getTextures(onTextureName01)[0]),
                new Icon(BenjiKIV.assetLoader.getTextures(onTextureName01)[0])
            ),
            colorSet,
            new PointerStateIconSet(
                new Icon(BenjiKIV.assetLoader.getTextures(offTextureName01)[0]),
                new Icon(BenjiKIV.assetLoader.getTextures(offTextureName01)[0]),
                new Icon(BenjiKIV.assetLoader.getTextures(offTextureName01)[0]),
                new Icon(BenjiKIV.assetLoader.getTextures(offTextureName01)[0])
            ),
            colorSet
        );
        this._level01Button.hitArea = new PIXI.Circle(72, 72, 55);
        this._level01Button.addClickCallback(() => this.level01Toggle(true));
        this._level01Button.toggled = false;
        this._level01Button.enable(true);

        this._level01OnSprite = new PIXI.Sprite(BenjiKIV.assetLoader.getTextures(onTextureName01)[0]);
        this._level01OnSprite.visible = false;
        this._level01OnSprite.blendMode = PIXI.BLEND_MODES.ADD;

        this._level01Normal = new PIXI.Sprite(BenjiKIV.assetLoader.getTextures(onTextureName01)[0]);

        this._level01Attention = new TimelineSprite(BenjiKIV.assetLoader.getTextures("X_Bet_Attention/X_Bet_Attention_"));
        this._level01Attention.hide();
        this._level01Attention.blendMode = PIXI.BLEND_MODES.ADD;

        this._xBetBlueReelOverlay = new PIXI.Sprite(BenjiKIV.assetLoader.getTextures("X_Bet/X_Frame_Blue")[0]);
        this._xBetBlueReelOverlay.visible = false;
        this._xBetBlueReelOverlay.position.set(70, 434);
        this._xBetBlueReelOverlay.anchor.set(0.5);

      //  this.addChild(this._level01Button, this._level01Normal, this._level01OnSprite, this._level01Attention, this._xBetBlueReelOverlay);
        this.addChild( this._xBetBlueReelOverlay);

        const textureName02: string = "X_Bet/Xbet_A_";
        const onTextureName02: string = textureName02 + "On";
        const offTextureName02: string = textureName02 + "Off";

        this._level02Button = new IconToggleButton("level2",
            new PointerStateIconSet(
                new Icon(BenjiKIV.assetLoader.getTextures(onTextureName02)[0]),
                new Icon(BenjiKIV.assetLoader.getTextures(onTextureName02)[0]),
                new Icon(BenjiKIV.assetLoader.getTextures(onTextureName02)[0]),
                new Icon(BenjiKIV.assetLoader.getTextures(onTextureName02)[0])
            ),
            colorSet,
            new PointerStateIconSet(
                new Icon(BenjiKIV.assetLoader.getTextures(offTextureName02)[0]),
                new Icon(BenjiKIV.assetLoader.getTextures(offTextureName02)[0]),
                new Icon(BenjiKIV.assetLoader.getTextures(offTextureName02)[0]),
                new Icon(BenjiKIV.assetLoader.getTextures(offTextureName02)[0])
            ),
            colorSet
        );
        this._level02Button.hitArea = new PIXI.Circle(72, 72, 55);
        this._level02Button.addClickCallback(() => this.level02Toggle(true));
        this._level02Button.toggled = false;
        this._level02Button.enable(true);

        this._level02OnSprite = new PIXI.Sprite(BenjiKIV.assetLoader.getTextures(onTextureName02)[0]);
        this._level02OnSprite.visible = false;
        this._level02OnSprite.blendMode = PIXI.BLEND_MODES.ADD;

        this._level02Normal = new PIXI.Sprite(BenjiKIV.assetLoader.getTextures(onTextureName02)[0]);

        this._level02Attention = new TimelineSprite(BenjiKIV.assetLoader.getTextures("X_Bet_Attention/X_Bet_Attention_"));
        this._level02Attention.hide();
        this._level02Attention.blendMode = PIXI.BLEND_MODES.ADD;

        //this.addChild(this._level02Button, this._level02Normal, this._level02OnSprite, this._level02Attention);

        // https://github.com/nolimitcity/QA/issues/587
        this._level02Button.visible = BenjiKIV.xBetRedAllowed;
        this._level02Normal.visible = BenjiKIV.xBetRedAllowed;
    }

    private playAttentionTl(): void {
        if (this._betBoostPaused || !this._betBoostAllowed || this._boosted01Enabled || this._boosted02Enabled || (!this._isBoost1EnabledFromKeypad && !this._isBoost2EnabledFromKeypad)) {
            return;
        }

        // #260, #261
        this.killAttention();

        let level: number = MathHelper.randomIntInRange(1, 2),
            tl: gsap.core.Timeline = gsap.timeline({
                delay: MathHelper.randomNumberInRange(5, 8)
            }),
            attentionItem: TimelineSprite;

        // #260, https://github.com/nolimitcity/QA/issues/587
        if ((level === 2) && (!this._isBoost2EnabledFromKeypad || !BenjiKIV.xBetRedAllowed)) {
            level = 1;
        }

        if (level === 1) {
            attentionItem = this._level01Attention;
            attentionItem.position = this._level01Button.position;
        } else {
            attentionItem = this._level02Attention;
            attentionItem.position = this._level02Button.position;
        }

        tl.add(attentionItem.getAnimationAutoShowHide(true, true));
        tl.add(() => {
            this.playAttentionTl();
        });

        this._attentionTl = tl;
    }

    private killAttention(): void {
        if (this._attentionTl) {
            this._attentionTl.pause();
            this._attentionTl.kill();

            this._attentionTl = null;
        }

        // #261
        gsap.killTweensOf(this._level01Attention);
        gsap.killTweensOf(this._level02Attention);

        this._level01Attention.hide();
        this._level02Attention.hide();
    }

    // #175
    private playXBetBlueReelOverlay(): void {
        const tl: gsap.core.Timeline = gsap.timeline();

        if (this._xBetBlueReelOverlay.visible) {
            return;
        }

        if (this._xBetBlueReelOverlayTl) {
            this._xBetBlueReelOverlayTl.pause();
            this._xBetBlueReelOverlayTl.kill();
        }

        this._xBetBlueReelOverlay.alpha = 0;
        this._xBetBlueReelOverlay.visible = true;

        tl.to(this._xBetBlueReelOverlay, {
            duration: 0.3,
            alpha: 1
        });

        this._xBetBlueReelOverlayTl = tl;
    }

    set isFeatureBuyAbort(value:boolean) {
        this._isFeatureBuyAbort = value;
    }

    // #260
    private onBetLevelChangeFromKeypad(currentBet: number): void {
        if (!this._betBoostAllowed || this._betBoostPaused || this._isReplay || this._isFeatureBuyAbort || this._isFreeBets) {
            return;
        }

        if (this._isPromoPanelClosed) {
            if (currentBet > BenjiKIV.boostBet1AllowedBetLevel) {
                this._boosted01Enabled = false;
                if (this._isBoost1EnabledFromKeypad && this._level01OnSprite.visible) {
                    BenjiKIV.apiPlugin.betHandler.setBoost(undefined);
                }
                this._level01OnSprite.visible = false;

                this.stopXBetBlueReelOverlay();

                this._isBoost1EnabledFromKeypad = false;
                this._level01Button.enable(false);

                this._level01Normal.alpha = 0.4;
            } else if (!BenjiKIV.model.isRestore) {
                this._isBoost1EnabledFromKeypad = true;
                this._level01Button.enable(!this._hasBetPlaced);

                this._level01Normal.alpha = 1;
            }

            // https://github.com/nolimitcity/QA/issues/587
            if (BenjiKIV.xBetRedAllowed) {
                if (currentBet > BenjiKIV.boostBet2AllowedBetLevel) {
                    this._boosted02Enabled = false;
                    if (this._isBoost2EnabledFromKeypad && this._level02OnSprite.visible) {
                        BenjiKIV.apiPlugin.betHandler.setBoost(undefined);
                    }
                    this._level02OnSprite.visible = false;

                    if (this._activateBoost2TL && this._activateBoost2TL.isActive()) {
                        this._activateBoost2TL.pause();
                    }
                    BenjiKIV.overlayScatterView.deActivateBoostedOverlays();

                    this._isBoost2EnabledFromKeypad = false;
                    this._level02Button.enable(false);

                    this._level02Normal.alpha = 0.4;
                } else if (!BenjiKIV.model.isRestore) {
                    this._isBoost2EnabledFromKeypad = true;
                    this._level02Button.enable(!this._hasBetPlaced);

                    this._level02Normal.alpha = 1;
                }
            }

            if (this._isBoost1EnabledFromKeypad && !this._isBoost2EnabledFromKeypad && this._level02Button.toggled) {
                this._level01Normal.visible = true;

                this._level02Button.toggled = false;
            }
            if (!this._isBoost1EnabledFromKeypad && !this._isBoost2EnabledFromKeypad) {
                this._level01Normal.visible = true;
                this._level02Normal.visible = BenjiKIV.xBetRedAllowed; // https://github.com/nolimitcity/QA/issues/587

                this._level01Button.toggled = false;
                this._level02Button.toggled = false;
            }

            this.killAttention();
            if (!this._hasBetPlaced && (this._isBoost1EnabledFromKeypad || this._isBoost2EnabledFromKeypad) && !this._boosted01Enabled && !this._boosted02Enabled) {
                this.playAttentionTl();
            }
        }
    }

    // #260
    private onPromoPanelOpened(): void {
        this._isPromoPanelClosed = false;
        console.log("hi");
    }

    // #260
    private onPromoPanelClosed(): void {
        this._isPromoPanelClosed = true;
        console.log("bye");
    }

    // #260
    set hasBetPlaced(value: boolean) {
        this._hasBetPlaced = value;
    }
}